import React from 'react';
import Button from '../_custom/Button/Button';
import { uploadDataIcon } from '../../assets/hostedassets';
import styles from './ModuleUploadDataButton.module.scss';
import { UPLOAD_DATA_LABEL } from '../../utils/constants/commonConstants';
import type { TabBarAction } from '../TabBarActions/TabBarActions';
import useMagicUploadLogic from '../MagicUpload/useMagicUploadLogic';
import { useIsMobile } from '../_custom/Hooks/useIsMobile';
import { useAppSelector } from '../../app/hooks';
import { USER_TYPE } from '../../utils/constants/user';
import { VISIBILITY_KEYS } from '../../utils/constants/visibilityKeys';
import { useFeatureVisibility, useVisibilityConfig } from '../../utils/useVisibilityConfig';

const LENDER_OR_PARTNER_TYPES: string[] = [USER_TYPE.LENDER, USER_TYPE.LENDER_TEAM, USER_TYPE.PARTNER];
const MAGIC_UPLOAD_VISIBILITY_KEYS = { magicUploadVisibility: VISIBILITY_KEYS.MAGIC_UPLOAD.ENABLED };

/**
 * The module "Upload Data" action (Banking, Financials). Investors always get it; lenders and partners only
 * where the header's Magic Upload is enabled — the union of today's Magic Upload entry points.
 */
export function useModuleUploadDataAction(companyName: string, isPDFReport: boolean): TabBarAction | null {
    const isMobile = useIsMobile();
    const accountType = useAppSelector((state) => state.user.userData.accountType);
    const { isConfigLoaded } = useVisibilityConfig();
    const { magicUploadVisibility } = useFeatureVisibility(MAGIC_UPLOAD_VISIBILITY_KEYS);
    const { openCompanyMagicUpload } = useMagicUploadLogic();

    const isPartnerOrLender = LENDER_OR_PARTNER_TYPES.includes(accountType);
    // getFeatureVisibility fails open until the config resolves, so a lender never sees a flash of the button.
    const isAllowed = !isPartnerOrLender || (isConfigLoaded && magicUploadVisibility.show);
    if (isMobile || isPDFReport || !isAllowed) return null;

    const openMagicUpload = () => openCompanyMagicUpload(companyName);
    return {
        id: 'uploadData',
        inline: (
            <Button
                type="button"
                className={styles.ModuleUploadDataButton}
                icon={<img src={uploadDataIcon} alt="" aria-hidden="true" className={styles.Icon} />}
                text={UPLOAD_DATA_LABEL}
                onClick={openMagicUpload}
            />
        ),
        menuItem: { name: UPLOAD_DATA_LABEL, onClick: openMagicUpload },
    };
}
